import { Outlet } from 'react-router';

import { AppHeader } from '@/components/AppHeader';
import { AppFooter } from '@/components/AppFooter';
import { useIframeHeightReporter } from '@/features/embed/useIframeHeightReporter';

/** Application shell for the authenticated area. */
export function AppLayout() {
  // Keeps the embedding host page's iframe sized to the content.
  useIframeHeightReporter();

  return (
    <div className="md-app">
      <AppHeader />
      <main className="md-main">
        <Outlet />
      </main>
      <AppFooter />
    </div>
  );
}
